export const VACATIONS_RECIEVED = "VACATIONS_RECIEVED"
export const VACATION_SAVED = "VACATION_SAVED"
export const VACATION_DELETED = "VACATION_DELETED"
export const VACATION_UNLOADED = "VACATION_UNLOADED"
